import { ItemFloatKind } from '@/constants/constants';
import { getUrl } from '@/utils/commonUtils';
export const upgrade1GbItem2Notification = (productItem) => {
  const item2Return = {
    ...productItem,
  };
  item2Return.itemKind = ItemFloatKind.UPGRADE1GB;
  item2Return.id = item2Return.productId;
  item2Return.code = item2Return.productId;
  item2Return.title =
    'Aún no has subido tu fibra hasta 1 Gb. Activa tu subida ahora.';
  item2Return.color = 'Blue';
  item2Return.icon = 'Fibra';
  item2Return.description = `<span class="status ${item2Return.color}">${item2Return.title}</span>`;
  return item2Return;
};

export const upgrade300MbItem2Notification = (productItem) => {
  const item2Return = {
    ...productItem,
  };
  item2Return.itemKind = ItemFloatKind.UPGRADE1GB;
  item2Return.id = item2Return.productId;
  item2Return.code = item2Return.productId;
  item2Return.title =
    'Aún no has subido tu fibra a 300 Mb. Activa tu subida ahora.';
  item2Return.color = 'Blue';
  item2Return.icon = 'Fibra';
  item2Return.description = `<span class="status ${item2Return.color}">${item2Return.title}</span>`;
  return item2Return;
};

export const debtPaymentItem2Notification = (urlLibrary) => {
  const item2Return = {};
  item2Return.itemKind = ItemFloatKind.DEBTPAYMENT;
  item2Return.id = 'notificacion-pago-de-deuda';
  item2Return.code = 'notificacion-pago-de-deuda';
  item2Return.title = 'Tienes facturas pendientes de pago.';
  item2Return.color = 'Blue';
  item2Return.icon = 'PagarFacturas';
  item2Return.description = `<span class="status ${item2Return.color}">${item2Return.title}</span>`;
  item2Return.link = `https://www.movistar.es/cliente/areaprivada/#${getUrl(
    'debtPayment',urlLibrary
  )}`;
  return item2Return;
};

export const mobileRent2RentItem2Notification = (
  productItem,
  isRent2Rent,
  isRent2RentAdditional,
  pikolin
) => {
  const item2Return = {
    ...productItem,
  };
  item2Return.itemKind = ItemFloatKind.MOBILERENT2RENT;
  if (isRent2Rent) {
    item2Return.id = 'incluido';
    item2Return.code = 'incluido';
    item2Return.title =
      'Ya puedes elegir tu dispositivo incluido en Fusión. Pídelo ahora.';
    if (pikolin) {
      item2Return.title =
        'Ya puedes elegir tu dispositivo incluido en miMovistar. Pídelo ahora.';
    }
  } else if (isRent2RentAdditional) {
    item2Return.id = 'adicional';
    item2Return.code = 'adicional';
    item2Return.title =
      'Añade un dispositivo adicional a tu Fusión a un precio muy especial.';
    if (pikolin) {
      item2Return.title =
        'Añade un dispositivo adicional a un precio muy especial. Pídelo ahora.';
    }
  }
  item2Return.color = 'Blue';
  item2Return.icon = 'Movil';
  item2Return.description = `<span class="status ${item2Return.color}">${item2Return.title}</span>`;
  return item2Return;
};
